import { Filter, LobbyFilter, PrivateTournamentFilter } from './filter/LobbyFilters'
import { BuyInFilter, FormatFilter, LimitsFilter, TournamentTypeFilter } from './filter/MenuFilters'
import { Injectable } from './injector'
import { Settings } from './Settings'
import { Status } from './data/LobbyData'
import { FeatureToggleTableFilter } from './filter/FeatureToggleTableFilter'
import { AuthService } from './auth/AuthService'
import { StaffOnlyTableFilter } from './filter/StaffOnlyTableFilter'

export enum FormatType {
    HOLDEM = 'TEXAS_HOLDEM',
    OMAHA = 'OMAHA',
    PINEAPPLE = 'CRAZY_PINEAPPLE',
    OMAHA_HL = 'OMAHA_HL',
}

export enum BuyInType {
    MICRO = 'MICRO',
		LOW = 'LOW',
		MEDIUM = 'MEDIUM',
		HIGH = 'HIGH',
}

export enum LimitType {
    NONE = 'NO_LIMIT',
    POT = 'POT_LIMIT',
    FIXED = 'FIXED_LIMIT',
}

export enum TournamentType {
    REGULAR = 'REGULAR',
		GUARANTEED = 'GUARANTEED',
		SATELLITE = 'SATELLITE',
		REBUY = 'REBUY',
		BOUNTY = 'BOUNTY',
}

@Injectable()
export class FilterManager {
	readonly ringGameFilters: Filter[]
	readonly sitAndGoFilters: Filter[]
	readonly tournamentFilters: Filter[]

	readonly formatFilter = new FormatFilter()
	readonly limitsFilter = new LimitsFilter()
	readonly buyInFilter = new BuyInFilter()
	readonly tournamentTypeFilter: TournamentTypeFilter = new TournamentTypeFilter()

	readonly fullTablesFilter: LobbyFilter
	readonly registeringOnlyFilter: LobbyFilter
	readonly rebuyEnabledFilter: LobbyFilter
	readonly featureToggleFilter: Filter
	readonly staffOnlyTableFilter: Filter

	constructor() {
		const fullTablesFilterEnabled = Settings.isEnabled(Settings.Param.FILTER_MISC_FULL_TABLES, false)
		this.fullTablesFilter = new LobbyFilter('hideFullTables', fullTablesFilterEnabled,
			(enabled, lobbyData) => {
				if (enabled) {
					return lobbyData.seated < lobbyData.capacity
				} else {
					return true
				}
			})

		const registeringOnlyFilterEnabled = Settings.isEnabled(Settings.Param.FILTER_MISC_REGISTERING_ONLY, false)
		this.registeringOnlyFilter = new LobbyFilter('registeringOnlyFilter', registeringOnlyFilterEnabled,
			(enabled, lobbyData) => {
				if (enabled) {
					return lobbyData.registrationOpen || lobbyData.status === Status.REGISTERING
				} else {
					return true
				}
			})

		const rebuyEnabledFilterEnabled = Settings.isEnabled(Settings.Param.FILTER_TT_REBUY_ENABLED, false)
		this.rebuyEnabledFilter = new LobbyFilter(
			'rebuyEnabledFilter',
			rebuyEnabledFilterEnabled,
			(enabled, lobbyData) => {
				return enabled
					? lobbyData.isRebuyEnabled
					: true
			})

		const userId = AuthService.getCurrentUserIdSynchronous()
		this.featureToggleFilter = new FeatureToggleTableFilter(userId)
		this.staffOnlyTableFilter = new StaffOnlyTableFilter(userId)

		this.ringGameFilters = [
			this.formatFilter,
			this.limitsFilter,
			this.buyInFilter,
			this.fullTablesFilter,
			this.featureToggleFilter,
			this.staffOnlyTableFilter,
		]
		this.sitAndGoFilters = [
			this.formatFilter,
			this.limitsFilter,
			this.buyInFilter,
			this.registeringOnlyFilter,
			new PrivateTournamentFilter(),
		]
		this.tournamentFilters = [
			this.tournamentTypeFilter,
			this.formatFilter,
			this.buyInFilter,
			this.registeringOnlyFilter,
			new PrivateTournamentFilter(),
		]
	}
}
